<div
  [class.chosen]="isFocusedDay"
  class="day-column">

  <h4><span>{{dayNumber}}</span><strong translate>{{dayName}}</strong> @if (isFocusedDay) {
  <span class="current-label" translate>SCHEDULE_INTERVIEW.TIME.CURRENT_SELECTION</span>
}</h4>

@if (!isScheduleFull && (!daySlots || daySlots.totalRemainingAppointements <= 0)) {
  <p translate class="slot-invalid">SCHEDULE_INTERVIEW.TIME.NONE_AVAILABLE</p>
}
@if (isScheduleFull) {
  <p class="schedule-full">{{'SCHEDULE_INTERVIEW.DATE.DAY_FULL' | translate | titlecase}}</p>
}

@if (daySlots && daySlots.totalRemainingAppointements > 0) {
  <table class="table">
    @if (daySlots && daySlots.remainingMorningAppointments > 0) {
      <tr class="morning">
        <th scope="col" class="text-center">
          <span class="label">
            <span class="interior" translate>
              SCHEDULE_INTERVIEW.TIME.MORNING
            </span>
          </span>
        </th>
      </tr>
    }
    @for (slot of daySlots.morningSlots; track slot; let i = $index) {
      <tr>
        @if (slot.available > 0 && !slot.expired) {
          <td class="slot-morning">
            <button [id]="'btnDay' + dayNumber + i + 'Time'" class="btn btn-appointment-time" (click)="dayPopover.toggle();" (focus)="dayPopover.hide()" [disabled]="viewOnly">
              {{slot.slotDisplayHour}}:{{slot.slotDisplayMinute}}
              <span translate>SCHEDULE_INTERVIEW.TIME.AM</span>
            </button>
            <app-popover [id]="'popoverDay' + dayNumber + i + 'Time'" (onClosed)="focusElement('btnDay' + dayNumber + i + 'Time')" #dayPopover>
              <h3 class="popover-title" translate>SCHEDULE_INTERVIEW.TIME.POPOVER.title</h3>
              <div class="popover-content">
                <div class="nextAppointment">
                  {{slot.slotDisplayHour}}:{{slot.slotDisplayMinute}}
                  <span translate>SCHEDULE_INTERVIEW.TIME.AM</span>
                </div>
                <div class="nextAppointment">
                  <span translate>{{month}}</span> {{slot.date | date: 'dd, y'}}
                </div>
                <div class="timeSlotTotal">
                  ({{slot.available}} <span translate>SCHEDULE_INTERVIEW.TIME.AVAILABLE</span>)
                </div>
                <div class="actionRow">
                  <button id="btnChoose" class="btn btn-primary"
                    (click)="selectedTime.emit(slot)"
                    (keyup.enter)="selectedTime.emit(slot)"
                    (keydown.tab)="dayPopover.hide()">
                    <span translate>SCHEDULE_INTERVIEW.TIME.POPOVER.chooseTime</span>
                  </button>
                  <sub translate>SCHEDULE_INTERVIEW.TIME.POPOVER.proceedToReview</sub>
                </div>
              </div>
            </app-popover>
            <sub>({{slot.available}} <span translate>SCHEDULE_INTERVIEW.TIME.AVAILABLE</span>)</sub>
          </td>
        }
      </tr>
    }
    @if (daySlots && daySlots.remainingAfternoonAppointments > 0) {
      <tr class="afternoon">
        <td class="text-center">
          <span class="label">
            <span class="interior" translate>
              SCHEDULE_INTERVIEW.TIME.AFTERNOON
            </span>
          </span>
        </td>
      </tr>
    }
    @for (slot of daySlots.afternoonSlots; track slot; let i = $index) {
      <tr>
        @if (slot.available > 0 && !slot.expired) {
          <td class="slot-afternoon">
            <button [id]="'btnAfternoon' + dayNumber + i + 'Time'" class="btn btn-appointment-time" (click)="afternoonPopover.toggle()" (focus)="afternoonPopover.hide()" [disabled]="viewOnly">
              {{slot.slotDisplayHour}}:{{slot.slotDisplayMinute}}
              <span translate>SCHEDULE_INTERVIEW.TIME.PM</span>
            </button>
            <app-popover [id]="'popoverAfternoon' + dayNumber + i + 'Time'" (onClosed)="focusElement('btnAfternoon' + dayNumber + i + 'Time')" #afternoonPopover>
              <h3 class="popover-title" translate>SCHEDULE_INTERVIEW.TIME.POPOVER.title</h3>
              <div class="popover-content">
                <div class="nextAppointment">
                  {{slot.slotDisplayHour}}:{{slot.slotDisplayMinute}}
                  <span translate>SCHEDULE_INTERVIEW.TIME.PM</span>
                </div>
                <div class="nextAppointment">
                  <span translate>{{month}}</span> {{slot.date | date: 'dd, y'}}
                </div>
                <div class="timeSlotTotal">
                  ({{slot.available}} <span translate>SCHEDULE_INTERVIEW.TIME.AVAILABLE</span>)
                </div>
                <div class="actionRow">
                  <button id="btnChoose" class="btn btn-primary"
                    (click)="selectedTime.emit(slot)"
                    (keyup.enter)="selectedTime.emit(slot)"
                    (keydown.tab)="afternoonPopover.hide()">
                    <span translate>SCHEDULE_INTERVIEW.TIME.POPOVER.chooseTime</span>
                  </button>
                  <sub translate>SCHEDULE_INTERVIEW.TIME.POPOVER.proceedToReview</sub>
                </div>
              </div>
            </app-popover>
            <sub>({{slot.available}} <span translate>SCHEDULE_INTERVIEW.TIME.AVAILABLE</span>)</sub>
          </td>
        }
      </tr>
    }
  </table>
}

</div>